import React, { useEffect } from 'react';
import { Redirect, Route, Switch, BrowserRouter } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { MODULE_NAMES } from '../constants';
// Components
import Dashboard from './dashboard/Dashboard';
import SessionBuilder from './sessions/SessionBuilder';
import AddOrEditSession from './sessions/AddOrEditSession';
import ExpertiseVerification from './expertise_verification/ExpertiseVerification';
import RatingTemplateForm from './rating_templates/RatingTemplateForm';
import ListRatingTemplates from './rating_templates/ListRatingTemplates';
import ErrorPage from './ErrorPage';
import QuestionBuilder from './question_builder/QuestionBuilder';
import SessionVisibility from './sessions/SessionVisibility';
import SessionSettings from './sessions/SessionSettings';
import CoinsSettings from './sessions/CoinsSettings';
import SideBar from './SideBar';
import SessionApproval from './SessionApproval/SessionApproval';
import ManageCompanies from './companies/ManageCompanies';
import Coach from './coach/Coach';
import CohortDashboard from './cohort/CohortDashboard';
import AlmaXCohortDashboard from './cohort/AlmaXCohortDashboard';

import { ToastContainer } from 'react-toastify';
import { loadAllCompanies } from '../redux/actions/companyActions';
import RBAC from '../pages/rbac/page';
import ProtectedRoute from '../extras/ProtectedRoute';
import CouponsTable from './coupons';
import BuildWebsite from './buildWebsite/BuildWebsite';
import CoachProfileVerification from './coach_verification/CoachVerification';
import PaymentLinks from '../pages/payment-links/page';
import CreateNewPaymentLink from '../pages/payment-links/create-new-payment-link/page';

import 'ag-grid-community/dist/styles/ag-grid.css';
import '../css/ag-grid-theme.css';
import ReferEarn from './referEarn';
import KycVerification from './coach_kyc/KycVerificationList';
import ProjectSubmissions from './projectSubmissions';
import AlmaX from './almaX';
import ManageClassroom from './manageClassroom';
import ManageABCAT from '../pages/manage-abcat-extension/page';
import JobBoard from '../pages/job-board/page';
import JobDashboardV2 from '../pages/job-dashboardv2/page';
import ManageBookingsRouter from '../pages/manage-bookings/router';
import AllUsersRouter from '../pages/all-users/router';
import StudentGroup from '../pages/student-groups/page.jsx';
import FreeUsers from '../pages/free-users/page';
import jobScrapingData from '../pages/job-data-scrapping/page';
import scrapeData from '../pages/job-data-scrapping/_components/scrapeData';
import ProgressCall from '../pages/progress-call/page';
import SupportSettings from '../pages/support-settings/page';

// import AlmaXCohorts from '../pages/almax-module/AlmaXCohorts';
// import AlmaXCohorts from '../pages/almax-module/almax-cohorts/AlmaXCohorts';
import AllAlmaXStudents from '../pages/almax-module/all-almax-students/AllAlmaXStudents';
import ABCATReport from '../pages/almax-module/abcat-report/ABCATReport';
import Shortlisting from '../pages/almax-module/shortlisting/Shortlisting';
// import CohortDashboard from './cohort/CohortDashboard';
// import AlmaXModuleCohortDashBoard from '../pages/almax-module/almax-cohorts/CohortDashboard';
import CohortDashBoard from '../pages/almax-module/almax-cohorts/CohortDashboard';
import CohortsModule from '../pages/almax-module/cohorts/page';

/* const loadThemesAndRatingTemplates = async (dispatch) => {
  try {
    dispatch(loadAllThemesFromApi());
    dispatch(loadAllRatingTemplates());
  } catch (e) {
    console.error(e);
  }
}; */

export function HomePage() {
  const dispatch = useDispatch();
  const modules = useSelector((state) => state.userReducer.modules);

  useEffect(() => {
    dispatch(loadAllCompanies());
  }, []);

  // Redirect to the first accessible sidebar route
  const firstAccessibleRoute = () => {
    if (modules.includes('super-admin')) return '/payment-links';
    const routeMap = [
      { module: MODULE_NAMES.SALES_MARKETING, path: '/payment-links' },
      { module: MODULE_NAMES.FREE_USERS_INVITE_DEMO_CLASS, path: '/free-users' },
      { module: 'coach-operations', path: '/coach' },
      { module: 'learning-tech', path: '/manage-bookings' },
      { module: 'student-operations', path: '/all-users' },
      { module: MODULE_NAMES.ALMAX_MODULE, path: '/ab-cat-report' },
      { module: 'jobDashboard', path: '/job-dashboardv2' },
      { module: 'jobScraping', path: '/job-scraping' },
    ];
    for (const { module, path } of routeMap) {
      if (modules.includes(module)) return path;
    }
    return '/dashboard'; // fallback
  };

  return (
    <div className='min-h-screen' style={{ backgroundColor: 'var(--page-background)', color: 'var(--text-primary)' }}>
      <BrowserRouter>
        <div className='flex min-h-screen'>
        <SideBar />
        <main className='flex-1 min-w-0 p-10 transition-all duration-300'>
          <Switch>
            <Route path='/dashboard' component={Dashboard} exact />
            <ProtectedRoute
              path='/expertise-verification'
              component={ExpertiseVerification}
            />
            {/* <ProtectedRoute
              path='/coach-v2'
              component={CoachVersionTwoRouter}
            /> */}
            <ProtectedRoute
              path='/coach-verification'
              component={CoachProfileVerification}
            />

            {/* Coach kYC - Verification */}
            <ProtectedRoute
              path='/kyc-verifications'
              component={KycVerification}
            />
            {/* kyc verification version 2 */}
            {/* <ProtectedRoute
              path='/kyc-verifications-v2'
              component={KycVerificationVersionTwoRouter}
            /> */}

            <ProtectedRoute path='/all-users' component={AllUsersRouter} />
            <ProtectedRoute path='/student-groups' component={StudentGroup} />
            <ProtectedRoute
              path='/all-almax-students'
              component={
                require('../pages/almax-module/all-almax-students/router.jsx')
                  .default
              }
            />

            <ProtectedRoute
              exact
              path='/session-builder'
              component={SessionBuilder}
            />
            <ProtectedRoute path='/new-session' component={AddOrEditSession} />
            <ProtectedRoute
              path='/session-builder/edit-session/:themeId'
              component={AddOrEditSession}
            />
            <ProtectedRoute
              path='/session-visibility'
              component={SessionVisibility}
            />
            <ProtectedRoute
              path='/session-settings'
              component={SessionSettings}
            />
            <ProtectedRoute
              path='/session-approval'
              component={SessionApproval}
            />

            <ProtectedRoute path='/coins-settings' component={CoinsSettings} />

            <ProtectedRoute path='/coupons' component={CouponsTable} />

            <ProtectedRoute path='/projects' component={ProjectSubmissions} />

            <ProtectedRoute path='/almax-submissions' component={AlmaX} />

            <ProtectedRoute
              path='/cohort-dashboard'
              component={CohortDashboard}
            />
            <ProtectedRoute
              path='/almax-dashboard'
              component={AlmaXCohortDashboard}
            />

            <ProtectedRoute
              path='/manage-companies'
              component={ManageCompanies}
            />

            <ProtectedRoute
              path='/new-rating-template'
              component={RatingTemplateForm}
            />
            <ProtectedRoute
              path='/list-rating-templates'
              component={ListRatingTemplates}
            />

            <ProtectedRoute
              path='/question-builder'
              component={QuestionBuilder}
            />

            <ProtectedRoute
              exact
              path='/payment-links'
              component={PaymentLinks}
            />
            <ProtectedRoute
              path='/payment-links/create-new-payment-link'
              component={CreateNewPaymentLink}
            />

            <ProtectedRoute
              path='/manage-bookings'
              component={ManageBookingsRouter}
            />

            <ProtectedRoute
              path='/manage-classroom'
              component={ManageClassroom}
            />
            <ProtectedRoute
              path='/manage-abcat-extension'
              component={ManageABCAT}
            />
            <ProtectedRoute path='/progress-call' component={ProgressCall} />
            <ProtectedRoute path='/refer-earn' component={ReferEarn} />
            <ProtectedRoute path='/free-users' component={FreeUsers} />

            <ProtectedRoute path='/coach' component={Coach} />

            <ProtectedRoute path='/job-board' component={JobBoard} exact />
            <Route path='/job-dashboardv2' component={JobDashboardV2} />
            <Route path='/job-scraping' component={jobScrapingData} />
            <Route path='/scrape-data' component={scrapeData} />

            <ProtectedRoute path='/support-settings' component={SupportSettings} />
            <ProtectedRoute path='/rbac' component={RBAC} exact />

            <ProtectedRoute
              path='/almabetter-website'
              component={BuildWebsite}
              exact
            />

            <ProtectedRoute path='/almax-cohorts' component={CohortDashBoard} />
            <ProtectedRoute path='/cohorts' component={CohortsModule} />
            <Route path='/add-cohort'><Redirect to='/cohorts' /></Route>
            <Route path='/scheduled-cohorts'><Redirect to='/cohorts' /></Route>
            <ProtectedRoute
              path='/almax-students'
              component={AllAlmaXStudents}
            />
            <ProtectedRoute path='/ab-cat-report' component={ABCATReport} />
            <ProtectedRoute path='/shortlisting' component={Shortlisting} />

            <Route exact path='/'>
              <Redirect to={firstAccessibleRoute()} />
            </Route>

            <Route component={ErrorPage} />
          </Switch>
        </main>
        </div>
      </BrowserRouter>
      <ToastContainer />
    </div>
  );
}

export default HomePage;
